<div class="pr-4 pl-2 pageheader">
  <div class="float-left mt-3">
    <h5 class="float-left">Add Requisition</h5>
  </div>
  <div class="float-right">
    <button class="m-2">Save</button>
    <button class="m-2" [routerLink]="['/']">Cancel</button>
  </div>
</div>

<div class="row mt-5">
  <label for="birthdate" class="ml-3" style="width:75px">Patient</label>
  <div class="ml-3" style="height:30px; width:500px; border: solid 1px darkgray">
    <div class="pull-left ml-2" style="height: 30px; width:375px">{{requisition.Patient.FirstName}} {{requisition.Patient.LastName}}</div>
    <a (click)="openPatientEdit()" class="pull-right" style="cursor:pointer"><i class="fa fa-user-plus mr-2"></i></a>
    <a (click)="openPatientEdit()" class="pull-right" style="cursor:pointer"><i class="fa fa-pencil mr-2"></i></a>
    <a (click)="patientsearch.show($event)" class="pull-right" style="cursor:pointer"><i class="fa fa-search mr-2"></i></a>
    <a (click)="patientinfo.show($event)" class="pull-right" style="cursor:pointer"><i class="fa fa-info mr-2"></i></a>
  </div>
</div>

<div class="row mt-2">
  <label for="birthdate" class="ml-3" style="width:75px">Client</label>
  <div class="ml-3" style="height:30px; width:500px; border: solid 1px darkgray">
    <div class="pull-left ml-2" style="height: 30px; width:400px; margin-top:1px;">
      {{client.Name}}
    </div>
    <a (click)="openClientEdit()" class="pull-right" style="cursor:pointer"><i class="fa fa-plus mr-2"></i></a>
    <a (click)="openClientEdit()" [hidden]="client == null || client.Id == null" class="pull-right" style="cursor:pointer"><i class="fa fa-pencil mr-2"></i></a>
    <a (click)="clientsearch.show($event)" class="pull-right" style="cursor:pointer"><i class="fa fa-search mr-2"></i></a>
    <a (click)="clientinfo.show($event)" [hidden]="client == null || client.Id == null" class="pull-right" style="cursor:pointer"><i class="fa fa-info mr-2"></i></a>
  </div>
</div>

<div class="row mt-2">
  <label for="birthdate" class="ml-3" style="width:75px">Provider</label>
  <div class="ml-3" style="height:40px; width:500px; border: solid 1px darkgray">
    <div class="pull-left ml-2" style="height: 37px; width:400px; margin-top:1px;">
      <p-select class="noborder" [options]="providers" [style]="{'width':'100%'}" [(ngModel)]="providerNPI"></p-select>
    </div>
    <a (click)="addProvider()" class="pull-right mt-2" style="cursor:pointer"><i class="fa fa-plus mr-2"></i></a>
    <a (click)="providerinfo.show($event)" class="pull-right mt-2" style="cursor:pointer"><i class="fa fa-info mr-2"></i></a>
  </div>
</div>

<p-fieldset legend="Test Information">
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col m-2">
          <label for="facility" class="toplabel">Test Name </label><br />
          <p-select [options]="testnames" [style]="{'width':'100%'}"></p-select>
        </div>
      </div>
    </div>
    <div class="col-6">
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <div class="row">
        <div class="col m-2">
          <label for="facility" class="toplabel">Specimen Type</label><br />
          <p-select [options]="specimentypes" [style]="{'width':'100%'}"></p-select>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col m-2">
          <label for="provider" class="toplabel">Date Collected</label><br />
          <p-datepicker id="birthdate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-datepicker>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col m-2">
          <label for="facility" class="toplabel">Collected By</label><br />
          <p-select [options]="collectors" [style]="{'width':'100%'}"></p-select>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="row">
        <div class="col m-2">
          <span class="ui-float-label">
            <input id="city" type="text" size="20" pInputText>
            <label for="city">Serial #</label>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-7">
      <label for="facility" class="toplabel">Dx Codes</label><br />
      <p-listbox [options]="dxcodes" multiple="multiple" [showToggleAll]="false"
                 checkbox="checkbox" [style]="{'width':'100%'}"></p-listbox>
    </div>
  </div>
</p-fieldset>


<p-popover #patientinfo [dismissable]="true">
  <ng-template pTemplate>
    <div style="width:600px">
      <div class="row">
        <div class="col-6"><b>Birthdate: </b>01/01/1960</div>
        <div class="col-6">123 Oak Street</div>
      </div>
      <div class="row">
        <div class="col-6"><b>Gender: </b>Female</div>
        <div class="col-6">Somewhere, KS 12345</div>
      </div>
      <div class="row">
        <div class="col-6"><b>Email: </b>bogus&#64;somedomain.com</div>
        <div class="col-6"></div>
      </div>
      <div class="row">
        <div class="col-6"><b>Phone: </b>(012) 345-6789</div>
        <div class="col-6"></div>
      </div>
    </div>
  </ng-template>
</p-popover>

<p-popover #clientinfo [dismissable]="true">
  <ng-template pTemplate>
    <div style="width:300px">
      <div class="row">
        <div class="col-12"><b>Name: </b>{{client.Name}}</div>
      </div>
      <div class="row">
        <div class="col-12"><b>Code: </b>{{client.Code}}</div>
      </div>
      <div class="row">
        <div class="col-12"><b>NPI: </b>{{client.NPI}}</div>
        <div class="col-12"></div>
      </div>
      <hr />
      <div class="row">
        <div class="col-12">{{client.Address1}}</div>
      </div>
      <div class="row">
        <div class="col-12">{{client.City}}, {{client.State}} {{client.ZipCode}}</div>
      </div>
    </div>
  </ng-template>
</p-popover>

<p-popover #providerinfo [dismissable]="true">
  <ng-template pTemplate>
    <div style="width:400px">
      <div class="row">
        <div class="col-6"><b>Name: </b>Dr. Feelgood</div>
        <div class="col-6"><b>NPI: </b>1234567890</div>
      </div>
    </div>
  </ng-template>
</p-popover>

<p-popover #patientsearch [dismissable]="true">
  <ng-template pTemplate>
    <div style="width:400px">
      <div class="row mb-3">
        <div class="col-12 ui-g-12 ui-md-4">
          <div class="ui-inputgroup">
            <input type="text" pInputText placeholder="Patient Search" [style]="{'width':'300px','height':'30px'}">
            <button pButton type="button" class="ui-button-icon-only pt-1" [style]="{'height':'30px'}"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-8">Joe Blow</div>
        <div class="col-4">10/23/1956</div>
      </div>
      <div class="row">
        <div class="col-8">Jamarius Bromanski</div>
        <div class="col-4">04/16/1967</div>
      </div>
      <div class="row">
        <div class="col-8">Belinda Philanges</div>
        <div class="col-4">08/03/1948</div>
      </div>
    </div>
  </ng-template>
</p-popover>

<p-popover #clientsearch [dismissable]="true">
  <ng-template pTemplate>
    <div style="width:400px">
      <div class="row mb-3">
        <div class="col-12 ui-g-12 ui-md-4">
          <div class="ui-inputgroup">
            <input type="text" [(ngModel)]="clientSearchString" pInputText placeholder="Client Search" [style]="{'width':'300px','height':'30px'}">
            <button pButton type="button" class="ui-button-icon-only pt-1" [style]="{'height':'30px'}" (click)="doClientSearch()"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
      <div class="selectableDiv" *ngFor="let client of clients; index as i" (click)="selectClient(clientsearch, i)">{{client.Name}}</div>
      <div class="font-italic mt-2" [hidden]="clients != null && clients.length > 0">Search for client name to display a list</div>
    </div>
  </ng-template>
</p-popover>

<p-popover #provideradd [dismissable]="true">
  <ng-template pTemplate>
    <div style="width:350px">
      <div class="row mb-3">
        <div class="col-12 ui-g-12 ui-md-4">
          <div class="ui-inputgroup">
            <input type="text" pInputText placeholder="Provider NPI" [style]="{'width':'300px','height':'30px'}">
            <button pButton type="button" class="ui-button-icon-only pt-1" [style]="{'height':'30px'}"><i class="fa fa-plus mt-1"></i></button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-popover>
